import Box from '@mui/material/Box';
// import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import withAuthAadhar from 'routes/iciciauthentication/aadharAuth';
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Checkbox } from 'antd';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';
import { useNavigate } from 'react-router';
import { handleCatchError } from 'utils/CatchHandler';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
// import TimerPage from './TimerPage';//timer
import AepsSDK from 'views/AepsSDK';
import { fetchBankListAPi, updateGstDetailsApi } from 'utils/API/Merchant APIs/AepsApiCalls';

import withAccessControlResetPassword from 'utils/HOC/resetPasswordHOC';
import Consent from './Consent';
import ReKYCDialog from 'views/Components/Dialogs/ReKycDialog';
import QrDisplayerComponent from 'views/Components/CommonCustomComponents/QrDisplayerComponent';
import { globalNotifyError, globalNotifySuccess, globalNotifyWarning } from 'views/utilities/AlertToast';
import BiometricDevices from 'views/Components/BiometricDevices/BiometricDevices';
import { handleCapture } from 'views/Components/BiometricDevices/BiometricCapture';
import BioAuthAnimation from 'views/Components/BiometricDevices/BioAuthAnimation';
import Spinner from 'views/Components/LoadingSinner';
import GstSubmitDialog from './GstSubmitDialog';
import styles from './gstSubmitDialog.module.css';
import { aadharExistApi, aadharPayApi, checkPermissionApi } from 'utils/API/Merchant APIs/UpdatedAPIs/AEPSUpdatedApiCall';

const commonStyles = {
    m: 0
};

function AadhaarPay() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMsgAadhar, setErrorMsgAadhar] = useState('');
    //STATE TO STORE DETAILS OF BANKS
    const [banks, setBanks] = useState([]);
    const [Aadhar, setAadhar] = useState('');
    const [errBanks, setErrBanks] = useState('');
    //STATES TO HANDLE VALIDATION OF INPUT FIELDS
    const [mobile, setMobile] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [amount, setAmount] = useState('');
    const [amountErr, setAmountErr] = useState('');
    const [showAllData, setShowAllData] = useState(false);
    const [sdkEnable, setSdkEnable] = useState(false);
    const [sdkCred, setSdkCred] = useState({});
    const [showConsent, setShowConsent] = useState(false);
    const [checked, setChecked] = useState(false);
    const [locationQr, setLocationQr] = useState('');
    const [aadharValidCheck, setAadharValidCheck] = useState('');
    //location
    const [, setLocation] = useState({
        latitude: null,
        longitude: null
    });
    //rekyc
    const [reKycDetails, setReKycDetails] = useState({ shouldOpen: false });
    const [selectedDeviceName, setSelectedDeviceName] = useState('');
    const [showFingerGif, setShowFingerGif] = useState(false);
    const [gstSubmitDetails, setGstSubmitDetails] = useState({ isCompleted: true, gstNumber: '', gstName: '', loading: false });
    const [gstFile, setGstFile] = useState({ file: '', base64: '', error: '', loading: false });
    const [success, setSuccess] = useState(false);
    const validExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
    const maxBase64SizeKB = 500;
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const ext = file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(ext)) {
            globalNotifyError(`Invalid file type. Allowed: PDF, JPG, JPEG, PNG`);
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result;
            const sizeInKB = (base64.length * (3 / 4)) / 1024;

            if (sizeInKB > maxBase64SizeKB) {
                globalNotifyError(`File size exceeds 500KB. Current size: ${Math.round(sizeInKB)}KB`);
                return;
            }

            setGstFile((prev) => ({ ...prev, file, base64 }));
        };
        reader.readAsDataURL(file);
    };
    const handleSubmitGstDetails = async (details) => {
        setGstSubmitDetails((prev) => ({ ...prev, loading: true }));
        const payload = {
            gstno: details.gstNumber,
            gst_document: details.documentBase64
        };
        const response = await updateGstDetailsApi(payload);
        setGstSubmitDetails((prev) => ({ ...prev, loading: false }));

        if (response?.status === 200) {
            globalNotifySuccess(response?.data?.message);
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false); // Reset for next open
                setGstSubmitDetails({ isCompleted: true, gstNumber: '', gstName: '', loading: false });
                handleCheckPermission();
            }, 2000);
        }
    };
    const handleDeviceSelect = (deviceName) => {
        setSelectedDeviceName(deviceName);
        console.log('deviceNameeee', deviceName);
    };
    const handleCheck = (e) => {
        setChecked(e.target.checked);
        setShowConsent(false);
    };
    const handleCheckPermission = async () => {
        setIsLoading(true);
        try {
            const response = await checkPermissionApi();

            const Data = response?.data?.data;
            const aeps_2FA_data = Data?.twoFactorAEPS;

            const geocheckSumvalue = Data?.geochecksumvalue;
            const apiUser = Data?.sdk_apiusername;
            const bcAgentId = Data?.bcagentId;
            const passKey = Data?.pass_key;
            const token = Data?.sdk_token;
            const aepsType = response?.data?.data?.aepsType;
            const isWhitelabel = response?.data?.data?.whitelabel;
            const aepsStatus = response?.data?.data?.aepsStatus;
            const gstStatus = response?.data?.data?.gst_status;
            if (!gstStatus) {
                globalNotifyWarning('GST details are required to proceed. Please submit them below.');
                setGstSubmitDetails((prev) => ({ ...prev, isCompleted: false }));
                setIsLoading(false);
                return;
            }
            if (aepsStatus !== 'enabled') {
                globalNotifyWarning('Aadhaar pay service have been disabled for your account.');
                navigate('/merchant-home');
                setIsLoading(false);
                return;
            }
            if (!isWhitelabel) {
                setReKycDetails({ shouldOpen: true });
            } else {
                setReKycDetails({ shouldOpen: false });
            }
            setShowAllData(response.data?.AP_twoFactor);
            if (aepsType === 'Fingpay') {
                setLocationQr(geocheckSumvalue);
                // if (response?.data?.aeps_2FA_data && response?.data?.AP_twoFactor) {
                if (response?.data?.AP_twoFactor === '1') {
                    navigate('/aeps1/aadhaarpay');
                } else {
                    if (aeps_2FA_data) {
                        // const scanner = true;

                        navigate('/aeps1/aepsauthentication', { state: { page: 'aadhaarpay' } });
                    } else {
                        navigate('/aeps1/aepsauthentication', { state: { page: 'aadhaarpay' } });
                    }
                }
            } else {
                setSdkCred({ apiUser, bcAgentId, passKey, token, cd_amount: '' });
                setSdkEnable(true);
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error.message);
            setIsLoading(false);
            handleCatchError(error);
        }
    };
    useEffect(() => {
        handleCheckPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [bankValue, setBankValue] = useState('');
    //FUNCTION TO CALL BANK LIST API
    const BankList = async () => {
        try {
            const response = await fetchBankListAPi();
            const BanksData = response?.data?.data;
            setBanks(BanksData);
        } catch (e) {
            console.log(e.message);
            handleCatchError(e);
        }
    };
    //FUNCTION TO HANDLE AADHAAR VALIDATION ERROR
    const validateAadhaar = () => {
        const re = /^[0-9]{12}$/; // Regular expression to match 10 digit mobile number
        if (!re.test(Aadhar)) {
            setErrorMsgAadhar('Please enter a valid 12 digit aadhaar number');
        } else {
            setErrorMsgAadhar('');
        }
    };

    //FUNCTION TO HANDLE VALIDATION ERROR
    const validateMobile = () => {
        const re = /^[6-9][0-9]{9}$/;
        // Regular expression to match 10 digit mobile number
        if (!re.test(mobile)) {
            setErrorMsg('Please enter a valid 10 digit mobile number starting with 6, 7, 8, or 9');
        } else {
            setErrorMsg('');
        }
    };
    const validateAmount = () => {
        if (!/^\d+(\.\d{1,2})?$/.test(amount) || parseFloat(amount) < 0) {
            setAmountErr('Please enter a valid amount.');
        } else {
            setAmountErr('');
        }
    };
    const validateBanks = () => {
        if (!banks) {
            setErrBanks('Please select a bank.');
        } else {
            setErrBanks('');
        }
    };

    const handleMobileChange = (e) => {
        let amountValue = e.target.value.replace(/[^\d]/g, '');
        if (amountValue.length > 0 && !['6', '7', '8', '9'].includes(amountValue[0])) {
            amountValue = '';
        }
        amountValue = amountValue.slice(0, 10);
        setMobile(amountValue);
    };

    const handleAadharChange = (e) => {
        let amountValue = e.target.value.replace(/[^\d.]/g, '');
        amountValue = amountValue.slice(0, 12);
        setAadhar(amountValue);
        if (amountValue.length === 12) {
            handleCheckAadhaarExist(amountValue);
        }
    };

    const handleAmountChange = (e) => {
        let amountValue = e.target.value.replace(/[^\d.]/g, '');
        amountValue = amountValue.slice(0, 6);
        setAmount(amountValue);
    };

    useEffect(() => {
        if (showAllData) {
            dispatch(fetchWalletBalanceAsync());
            BankList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showAllData]);

    //location function
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => {
                console.error(error);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function handleBankChange(event, newValue) {
        setBankValue(newValue);
    }
    //api call to get mini statement
    const fetchAadaarPay = async (data) => {
        setIsLoading(true);
        // const agent_id = localStorage.getItem('user_id');
        const agentId = '2146f726-d0b7-42d9-9822-861c5307a8b6';
        const nationalBankIdentification = bankValue?.iinno;
        const bank = bankValue?.bankName;
        const aadhaarNo = Aadhar;
        const mobileNumber = mobile;
        const transactionAmount = amount;
        // const latitude = location?.latitude;
        // const longitude = location?.longitude;
        try {
            const payload = {
                agentId,
                bank,
                nationalBankIdentification,
                aadhaarNo,
                mobileNumber,
                data,
                // latitude,
                // longitude,
                transactionAmount,
                invoice: gstFile?.base64
            };
            const response = await aadharPayApi(payload);

            const Data = response?.data;

            const object = Data?.data;
            const resData = response?.response?.data?.message || response?.data?.message;

            setIsLoading(false);
            if (Data?.success) {
                dispatch(fetchWalletBalanceAsync());
                globalNotifySuccess(Data?.message || response?.data?.message);

                navigate('/aeps1/aepsreceipt', { state: { object } });
                setAadhar('');
                setMobile('');
                setBanks('');
                setAmount('');
            } else {
                globalNotifyError(resData);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const handleCheckAadhaarExist = async (aadhaarNumber) => {
        try {
            setIsLoading(true);
            const payload = {
                aadharNo: aadhaarNumber,
                // agentid: localStorage.getItem('user_id'),
                type: 'AP'
            };
            const response = await aadharExistApi(payload);

            if (response?.data?.status) {
                const errorMsg = response?.data?.message || 'Invalid Aadhaar number';
                globalNotifyError(response?.data?.message);
                setErrorMsgAadhar(errorMsg);
                setAadharValidCheck(errorMsg);
            } else {
                setErrorMsgAadhar('');
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const handleShowConsent = () => {
        setShowConsent(true);
    };
    const onCaptureSuccess = (data) => {
        setShowFingerGif(false);
        if (!data === false) {
            fetchAadaarPay(data);
        }
    };
    const handleFingerAnimation = (deviceName) => {
        setShowFingerGif(true);
        const timeoutId = setTimeout(() => {
            handleCapture(deviceName, onCaptureSuccess);
        }, 1000);
        return () => clearTimeout(timeoutId);
    };
    return (
        <>
            {sdkEnable && sdkCred ? (
                <AepsSDK serviceName="aadhaar-pay" creds={sdkCred} />
            ) : (
                <>
                    {showAllData && (
                        <>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    backgroundColor: '#fff',
                                    ...commonStyles,
                                    borderRadius: 2,
                                    padding: '20px 10px',
                                    '@media screen and (min-width: 600px)': {
                                        padding: 2
                                    }
                                }}
                            >
                                <Typography variant="h3">
                                    <GlobalBackButton />
                                    Aadhaar pay
                                </Typography>
                                <Box sx={{ marginTop: '10px' }}>
                                    <Link to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <HomeOutlined />
                                    </Link>
                                    <Typography component="span" style={{ margin: '0 10px' }}>
                                        &gt;
                                    </Typography>
                                    <Typography component="span">Aadhaar pay</Typography>
                                </Box>
                            </Box>
                            {/* <<<<<<<Breadcrumb end here>>>>>>> */}
                            <Box sx={{ m: 2 }}></Box>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    // marginBottom: '10px',
                                    backgroundColor: '#fff',
                                    ...commonStyles,
                                    borderRadius: 2,
                                    padding: '20px 10px',
                                    '@media screen and (min-width: 600px)': {
                                        padding: 5
                                    }
                                }}
                            >
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Aadhaar Number"
                                                variant="outlined"
                                                fullWidth
                                                required
                                                value={Aadhar}
                                                helperText={errorMsgAadhar || aadharValidCheck}
                                                error={Boolean(errorMsgAadhar || aadharValidCheck)}
                                                onChange={handleAadharChange}
                                                onBlur={validateAadhaar}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Mobile Number"
                                                variant="outlined"
                                                fullWidth
                                                required
                                                value={mobile}
                                                helperText={errorMsg}
                                                error={Boolean(errorMsg)}
                                                onBlur={validateMobile}
                                                onChange={handleMobileChange}
                                            />
                                            {/* {errorMsg && <p>{errorMsg}</p>} */}
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Amount"
                                                variant="outlined"
                                                fullWidth
                                                required
                                                value={amount}
                                                helperText={amountErr}
                                                error={Boolean(amountErr)}
                                                onBlur={validateAmount}
                                                onChange={handleAmountChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                value={bankValue ? bankValue : null}
                                                options={banks ? banks : ''}
                                                helperText={errBanks}
                                                error={Boolean(errBanks)}
                                                onBlur={validateBanks}
                                                onChange={handleBankChange}
                                                getOptionLabel={(option) => (option?.bankName ? option?.bankName : '')}
                                                sx={{ width: '100%', mb: 1 }}
                                                renderInput={(params) => <TextField {...params} label="Select Bank *" />}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" label="Remarks" variant="outlined" fullWidth />
                                        </Grid>
                                        <Grid sx={{ mt: 3 }} item xs={12}>
                                            <label className={styles.fileUploadLabel}>
                                                Upload Invoice
                                                <input
                                                    type="file"
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    onChange={handleFileChange}
                                                    className={styles.fileInput}
                                                />
                                            </label>
                                        </Grid>
                                        {gstFile.file.name && (
                                            <Typography sx={{ mt: 2 }} variant="body2" className={styles.fileName}>
                                                Selected: {gstFile.file.name}
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                                        <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                            Scan QR Code from mobile application to fetch your geocoordinates
                                        </Typography>
                                        <QrDisplayerComponent value={locationQr} level={'M'} size={128} includeMargin={true} />
                                    </Box>
                                    <Checkbox checked={checked} onChange={handleCheck}>
                                        I accept the terms and conditions
                                    </Checkbox>
                                    <Button type="primary" onClick={handleShowConsent}>
                                        View
                                    </Button>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                        {!isLoading ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                fullWidth
                                                onClick={() => handleFingerAnimation(selectedDeviceName)}
                                                disabled={
                                                    !checked ||
                                                    !bankValue ||
                                                    !mobile ||
                                                    !Aadhar ||
                                                    !amount ||
                                                    aadharValidCheck ||
                                                    !gstFile.file
                                                }
                                            >
                                                {isLoading ? 'Loading' : 'Submit'}
                                            </Button>
                                        ) : (
                                            <Box sx={{ display: 'flex' }}>
                                                <CircularProgress />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                {/* <CountdownTimer initialSeconds={30} onTimerEnd={handleTimerEnd} /> */}
                                {/* <TimerPage page={'aadhaarpay'} /> */}
                                {/*timer*/}
                            </Box>
                        </>
                    )}
                </>
            )}
            {gstSubmitDetails.isCompleted ? (
                <BiometricDevices onDeviceSelect={handleDeviceSelect} />
            ) : (
                <GstSubmitDialog
                    isOpen={!gstSubmitDetails.isCompleted}
                    dialogWidth="1200px"
                    disableBackdropClick={true}
                    title="Submit GST Details"
                    onSubmit={handleSubmitGstDetails}
                    loading={gstSubmitDetails.loading}
                    showCloseButton={false}
                    isSuccess={success}
                />
            )}
            {showFingerGif && <BioAuthAnimation />}
            <Spinner loading={isLoading} />

            {showConsent && <Consent />}
            {!showAllData && <></>}
            {/* {showAuthAp && <Aeps_Authentication scanner={true} page={'aadhaarpay'} />}/ */}
            <ToastContainer />
            {reKycDetails.shouldOpen && <ReKYCDialog service="aeps_aadhaar_pay" />}
        </>
    );
}
export default withAccessControlResetPassword(withAuthAadhar(AadhaarPay));
